import { mergeStyles } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { InsertTableStyles } from "./RibbonInsertTable.Props";

export interface InsertTableClassNames {
  root?: string;
  cell?: string;
  tableTitle?: string;
  tableTitleInnerSpan?: string;
}

export const getClassNames = memoizeFunction(
  (
    styles: Partial<InsertTableStyles>,
    cellHighlighted: boolean,
    disabled: boolean
  ): InsertTableClassNames => {
    return {
      root: mergeStyles(styles.root),
      cell: mergeStyles(
        styles.cell,
        cellHighlighted && styles.cellHighlighted,
        disabled && styles.cellDisabled
      ),
      tableTitle: mergeStyles(styles.tableTitle),
      tableTitleInnerSpan: mergeStyles(styles.tableTitleInnerSpan),
    };
  }
);
